import MultiSelectDeleteModal from './MultiSelectDeleteModal';

export default MultiSelectDeleteModal;
